<ion-content>
  <ion-item lines="none" details="false">
    <ion-icon name="close" slot="start" (click)="close()"></ion-icon>
    <ion-label *ngIf="title || text">
      <ion-text color="primary" *ngIf="title">
        {{title}}
      </ion-text>
      <p *ngIf="text">
        {{text}}
      </p>
    </ion-label>
  </ion-item>

  <swiper-container [options]="sliderOpts" pager="true">
    <swiper-slide *ngFor="let img of images">
      <div class="swiper-zoom-container">
        <img [src]="img">
      </div>
    </swiper-slide>
  </swiper-container>
</ion-content>